import React from 'react';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import useStyle from './PedagogicalChallenges.style';
import { ContainerHalf } from 'components/layouts/ContainerHalf';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { ChallengesList } from './ChallengesList';
import { LastChallengeResult } from './LastChallengeResult';
import { HomeDefis } from 'graphql/generated/graphql';

interface PedagogicalChallengesViewProps {
  goToSinglePedagogicalChallenge: (id: number) => void;
  defis: HomeDefis;
}

export const PedagogicalChallengesView = ({
  goToSinglePedagogicalChallenge,
  defis
}: PedagogicalChallengesViewProps) => {
  const classes = useStyle();

  return (
    <>
      <BackButton text="Retourner sur Ma Classe" />{' '}
      <ContainerFullWidth>
        <FeatureContainer padding="small">
          <div className={classes.topModule}>Défis pédagogiques</div>
        </FeatureContainer>
        <ContainerHalf
          col1={
            <>
              <HeaderText
                text="Résultat du dernier défi"
                emoji={emojis['FlagInHole']}
              />
              <div className={classes.lastDefiContainer}>
                <FeatureContainer padding="small">
                  {defis.lastDefi !== null ? (
                    <LastChallengeResult defi={defis.lastDefi} />
                  ) : (
                    <p>
                      Pas de résultat à afficher{' '}
                      <span role="img" aria-label="Smiley triste">
                        🥹
                      </span>
                    </p>
                  )}
                </FeatureContainer>
              </div>
            </>
          }
          col2={
            <>
              <HeaderText
                text="Liste des défis"
                emoji={emojis['BookmarkTabs']}
              />
              <ChallengesList
                list={defis.defisList}
                goToSinglePedagogicalChallenge={goToSinglePedagogicalChallenge}
              />
            </>
          }
        />
      </ContainerFullWidth>
    </>
  );
};
